
import { Component, Mixins, Vue } from 'vue-property-decorator';
import { DatePicker, Tabs, TabPane } from 'element-ui';
import moment from 'moment';
import { tSearch } from '@/components/Search/index';
import { IPSearch } from '@/types/report.d';
import ipMap from './components/ipMap.vue';
import tableMixin from './tableMixins';
import SearchForm from './components/searchForm.vue';

@Component({
  components: {
    DatePicker,
    Tabs,
    TabPane,
    ipMap,
    SearchForm,
    tSearch,
  },
})

export default class ipView extends Mixins(tableMixin) {
  private time: Array<any> = [];

  private activeName: string = 'table';

  private searchValue: string = '';

  private searchForm: IPSearch = {
    userName: '',
    orgName: '',
    userLoginName: '',
  }

  public $refs!: {
    searchForm: SearchForm;
  }

  created() {
    this.time = [moment().startOf('week'), moment()];
    this.getData({ startTime: moment(this.time[0]).format('YYYY-MM-DD HH:mm:ss'), endTime: moment(this.time[1]).format('YYYY-MM-DD 23:59:59') });
  }

  /**
   * @author liangyongmou
   * @desc 搜索事件改变
   * @param { any } v 搜索值
   */
  timeChange(time: any) {
    this.time = time;
    this.getData({ startTime: moment(time[0]).format('YYYY-MM-DD HH:mm:ss'), endTime: moment(time[1]).format('YYYY-MM-DD 23:59:59') });
  }

  /**
   * @author liangyongmou
   * @desc 普通搜索改变
   * @param { any } v 搜索值
   */
  handleSearchChange(v: string) {
    this.getData({ userName: v, startTime: moment(this.time[0]).format('YYYY-MM-DD HH:mm:ss'), endTime: moment(this.time[1]).format('YYYY-MM-DD 23:59:59') });
  }

  /**
   * @author liangyongmou
   * @desc 高级搜索提交事件
   */
  handleAdvancedSearch() {
    const form: any = this.$refs.searchForm.getFormData();
    const params: any = {
      startTime: moment(this.time[0]).format('YYYY-MM-DD HH:mm:ss'),
      endTime: moment(this.time[1]).format('YYYY-MM-DD 23:59:59'),
      userName: form.userName,
      orgName: form.orgName,
      userLoginName: form.userLoginName,
    };
    const flag: boolean = Object.values(form).some((em: any) => em && em.length > 0);
    if (flag) this.getData(params);
  }

  /**
   * @author liangyongmou
   * @desc 高级搜索普通搜索切换事件
   * @param { boolean } activate 是否切换
   */
  handleActivateChange(activate: boolean) {
    if (activate) {
      this.$refs.searchForm.setTitle(this.searchValue);
      this.searchValue = '';
    } else this.searchValue = this.$refs.searchForm.getFormData().userName;
  }

  /**
   * @author liangyongmou
   * @desc 高级搜索清空按钮事件
   */
  handleAdvanceClear() {
    this.$refs.searchForm.handleClear();
    this.getData({ startTime: moment(this.time[0]).format('YYYY-MM-DD HH:mm:ss'), endTime: moment(this.time[1]).format('YYYY-MM-DD 23:59:59') });
  }
}
